<!-- this page currently holds all components conditionally rendered by step node passed from stepController  -->

<template>
  <div class="step-layout">
    <div class="step-content">
      <component
        v-if="currentNode && !isLoading"
        :is="currentNode.component"
        v-bind="componentProps"
        @input="onValueChange"
      />
      <div v-else-if="isLoading" class="loading-overlay">
        <b-spinner style="border-width: 2px" />
      </div>
    </div>

    <div class="step-nav" v-if="currentNode && !isLoading">
      <TongxinNavigation
        :canProceed="canProceed"
        :backButtonIsVisible="backButtonIsVisible"
        :nextButtonIsVisible="nextButtonVisible"
        :textForNextStep="textForNextStep"
        :isCentered="currentNode.component === 'Success'"
        @back="handleBack"
        @next="handleNext"
      />
    </div>
  </div>
</template>

<script>
import TongxinNavigation from '@/components/web/proj/tongxin/layout/TongxinNavigation.vue'
import SelectionStep from '@/components/web/proj/tongxin/SelectionStep.vue'
import Info from '@/components/web/proj/tongxin/Info.vue'
import AddOn from '@/components/web/proj/tongxin/AddOn.vue'
import Notice from '@/components/web/proj/tongxin/Notice.vue'
import TongxinDateSelector from '@/components/web/proj/tongxin/TongxinDateSelector.vue'
import AppointmentTimeSelector from '@/components/web/proj/tongxin/AppointmentTimeSelector.vue';
import stepController from '@/mixins/web/tongxin/stepController'
import CustomerServiceConfirmation from '@/components/web/proj/tongxin/CustomerServiceConfirmation.vue'
import Confirmation from '@/components/web/proj/tongxin/Confirmation.vue'
import Success from '@/components/web/proj/tongxin/Success.vue'
import UserNotes from '@/components/web/proj/tongxin/UserNotes.vue'

export default {
  name: 'DynamicStepContainer',
  components: {
    TongxinNavigation,
    SelectionStep,
    Info,
    AddOn,
    Notice,
    TongxinDateSelector,
    AppointmentTimeSelector,
    CustomerServiceConfirmation,
    Confirmation,
    Success,
    UserNotes,
  },
  mixins: [stepController],
  props: {
    stepId: {
      type: String,
      required: true
    }
  },
}
</script>

<style scoped>
.step-layout {
  display: flex;
  flex-direction: column;
}

.step-content {
  width: 100%;
  padding: 24px 16px 0; /* single source of spacing above content */
}

.step-nav {
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 32px 16px 16px;
  background: white;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 50%,
    rgba(255, 255, 255, 0.2) 100%
  );
  border-top: none;
  box-shadow: none;
}
</style>
